import api from './api';
import { AppResponse } from '../models/common/app-response';

export interface BrandingConfig {
  productName: string;
  organizationName: string;
  logoUrl?: string;
  primaryColor: string;
}

const branding = window.__env.branding;

export const defaultBranding: BrandingConfig = {
  productName: branding?.productName || 'Медосмотры',
  organizationName: branding?.organizationName || 'TeleMedConnect',
  logoUrl: branding?.logoUrl || undefined,
  primaryColor: branding?.primaryColor || '#9588e8',
};

class BrandingService {
  private baseUrl = '/api/v1/tenant-branding';

  get() {
    return api.get<AppResponse<BrandingConfig>>(this.baseUrl);
  }

  update(data: FormData) {
    return api.put<AppResponse<BrandingConfig>>(this.baseUrl, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export const brandingService = new BrandingService();
